import { useEffect, useState } from "react";
import { useTranslation as originalUseTranslation } from "react-i18next";

import type { Language } from "@/constants";
import { LANGUAGES } from "@/constants";

export const useTranslation = () => {
	const { t, i18n } = originalUseTranslation();
	const lang = i18n.language as Language;

	const [isRtl, setIsRtl] = useState<boolean>(() => {
		const lang = i18n.language as Language;
		return LANGUAGES[lang]?.mode === "rtl";
	});

	useEffect(() => {
		const handleLanguageChange = (lng: string) => {
			const lang = lng as Language;
			setIsRtl(LANGUAGES[lang]?.mode === "rtl");
		};

		i18n.on("languageChanged", handleLanguageChange);

		return () => {
			i18n.off("languageChanged", handleLanguageChange);
		};
	}, [i18n]);

	return { t, isRtl, i18n, lang };
};
